import type { RetailerEngagementRow } from "@/api/types";
import { HorizontalBarChart } from "@/components/HorizontalBarChart";

/**
 * Shopper engagement bucket pair: transactions and units per bucket.
 * Shared by the retailer activity and brand metrics dashboards.
 */
export function EngagementCharts({
  engagement,
}: {
  engagement: RetailerEngagementRow[];
}) {
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div>
        <div className="mb-2 text-sm font-medium">Transactions</div>
        <HorizontalBarChart
          data={engagement.map((e) => ({ name: e.bucket, value: e.transactions }))}
          seriesName="Transactions"
        />
      </div>
      <div>
        <div className="mb-2 text-sm font-medium">Units</div>
        <HorizontalBarChart
          data={engagement.map((e) => ({ name: e.bucket, value: e.units }))}
          seriesName="Units"
        />
      </div>
    </div>
  );
}
